
<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div slot="header" class="
        flex flex-wrap
        items-center
        flex-grow
        justify-between
        w-full
        mx-4
      ">
      

      <vs-row class="my-5 mx-4 ml-0">
        <vs-col vs-lg="5" vs-sm="12">
          <vs-row>
            <vs-button class="pl-4 ml-0" type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">Add
              Issuer</vs-button>
            <vs-button class="pl-4 ml-4" type="border" icon-pack="feather" icon="icon-plus" @click="editCard('')">Add
              Card</vs-button>
            <!-- <vs-button
            :disabled="selected.length <= 0"
            class="pl-8 ml-4 font-semibold center"
            type="filled"
            :color="actionBtnClr"
            @click="confirmDelete = true"
            >Delete</vs-button
          >-->
          </vs-row>
        </vs-col>
        <vs-col vs-lg="3" vs-sm="12"> </vs-col>
        <vs-col vs-lg="4" vs-sm="12">
          <vs-row vs-type="flex" vs-justify="flex-end">
            <input maxLength="30" type="text" name="search" class="search px-4 w-1/3 py-3 mr-4 shadow-lg"
              placeholder="Search..." @input="getAllIssuers('search')" v-model="search" autocomplete="off" />
          </vs-row>
        </vs-col>
      </vs-row>

       <vs-row class="my-5 mx-4 ml-0">
        <vs-col vs-lg="5" vs-sm="12">
          <vs-row>
            <div class="flex self-center ml-5">Linked {{this.totalIssuersLinkedWithPlaid}}/{{this.totalIssuers}}</div>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>

    <div v-if="cardsList && cardsList.length == 0 && showNoData == true" class="mb-5 mr-8">
      <vs-row class="tablerowHeight ml-4 mt-5 mb-5 mr-2" style="background-color: #343434 !important">
        <vs-col class="mt-6" vs-lg="10" vs-type="flex" vs-justify="center">
          <p class="font-medium truncate mt-1">No Data Available</p>
        </vs-col>
      </vs-row>
    </div>
    <div class="shadow-lg tblBgClr mx-4" :key="index" v-for="(row, index) in cardsList">
      <vs-table :multiple="row.cards[0].name ? true : false" v-model="selected[index]" :max-items="itemsPerPage"
        :data="row.cards" class="p-4" hoverFlat>
        <div slot="header" class="w-full p-0 mb-0">
          <vs-row vs-justify="space-between">
            <div>
              <div class="issuerCircle mb-1" :style="{
                'background-color': row.issuer_detail[0]
                  ? row.issuer_detail[0].color
                  : '#4B4BF9',
              }"></div>
              <div class="mb-4 verticalAlign ml-4 font-semibold displayInline">
                {{ row._id[0] }}
              </div>
              <div class="
                  mb-4
                  verticalAlign
                  ml-4
                  ruleHead
                  mt-1
                  font-semibold
                  displayInline
                " @click="setIssuerRuleStatus(row)">
                Active Rules ({{
                row.issuer_detail[0].activeRulesCount
                ? row.issuer_detail[0].activeRulesCount
                : 0
                }})
              </div>
               <div class="
                  mb-4
                  verticalAlign
                  ml-4
                  mt-1
                  displayInline
                " @click="setIssuerRuleStatus(row)"
                style="font-size: 12px;">
                <div class="bg-connected border-success p-2 rounded-lg" v-if="row.isLinkedWithPlaid">
                  Connected to Plaid
                </div>
                <div class="bg-danger p-2 rounded-lg" v-else>
                  Not connected to Plaid 
                </div>
              </div>
            </div>
            <div>
              <vs-button class="mr-3" @click="deleteIssr(row.issuer_detail[0]._id)">Delete</vs-button>
              <vs-button @click="editIssuer(row)">Edit</vs-button>
            </div>
          </vs-row>
        </div>

        <template v-if="row.cards[0].totalCards != undefined">
          <tbody>
            <vs-row :data="tr" :key="indextr" v-for="(tr, indextr) in row.cards" class="tablerowHeight ml-5">
              <vs-col class="mt-6" vs-lg="10">
                <p class="font-medium truncate">
                  {{ "TOTAL CARDS : " + tr.totalCards }}
                </p>
              </vs-col>

              <vs-col vs-lg="2" class="mt-5">
                <vs-button class="mr-3" :disabled="tr.totalCards == 0"
                  @click="ViewCards(row.issuer_detail[0].name)">View Cards</vs-button>
              </vs-col>
            </vs-row>
          </tbody>
        </template>
      </vs-table>

      <div class="
          flex flex-wrap-reverse
          items-center
          flex-grow
          py-5
          mb-3
          borderTop
          mx-5
          mt-3
        ">
        <router-link :to="{
          name: 'add card',
          params: { issuerInfo: row.issuer_detail[0] },
        }" style="color: white">
          <PlusSquareIcon />
        </router-link>
        <router-link :to="{
          name: 'add card',
          params: { issuerInfo: row.issuer_detail[0] },
        }">
          <h5 class="ml-2">Add Card</h5>
        </router-link>
      </div>
    </div>
    <vs-row>
      <vs-row>
        <vs-popup class="holamundo details" :title="cardInfo.name" :active.sync="showDetails">
          <img :src="$ApiKeys.IMAGE_BASE_URL + cardInfo.photo" class="title-icon" />
          <vs-row>
            <vs-row class="detailsBorder p-4">
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Issuer</p>
                <p class="detailContent pb-1">
                  {{ cardInfo ? cardInfo.issuer.name : "Not Available" }}
                </p>
                <p class="detailLabel pt-1">Card</p>
                <p class="detailContent pb-1">
                  {{ cardInfo ? cardInfo.name : "Not Available" }}
                </p>
                <p class="detailLabel pt-1">Product Change</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.product_change
                      ? cardInfo.product_change.name
                      : "Not Available"
                  }}
                </p>
                <vs-row class="inputContainer p-0">
                  <vs-checkbox v-model="cardInfo.five_twenty_four" vs-name="rule-type" :vs-value="true"
                    class="m-2 mt-5 ml-0" :disabled="true" />
                  <div class="detailContent pt-5">Counts toward Chase 5/24</div>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Card Type</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.card_type ? cardInfo.card_type : "Not Available"
                  }}
                </p>
                <p class="detailLabel pt-1">Upgrade Card</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.upgrade_card
                      ? cardInfo.upgrade_card.name
                      : "Not Available"
                  }}
                </p>
                <p class="detailLabel pt-1">Downgrade Card</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.downgrade_card
                      ? cardInfo.downgrade_card.name
                      : "Not Available"
                  }}
                </p>
              </vs-col>
            </vs-row>
            <vs-row class="detailsBorder p-4">
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Annual Fee</p>
                <p class="detailContent pb-1">${{ cardInfo.annual_fee }}</p>
                <!-- <p class="detailLabel pt-1">Effective Fee Description</p>
                                <p v-if="cardInfo.effective_fee_description" class="detailContent pt-1" v-html="cardInfo.effective_fee_description"></p>
                                <p class="detailContent pt-1" v-else>Not Available</p> -->
              </vs-col>
              <vs-col vs-lg="6">
                <p class="detailLabel">Points</p>
                <p class="detailContent" v-if="
                  cardInfo.points_categories &&
                  cardInfo.points_categories.length == 0
                ">
                  Not Available
                </p>
                <div v-if="cardInfo.points_categories">
                  <p class="detailContent" :key="index" v-for="(category, index) in cardInfo.points_categories">
                    {{ category.multiplier }} x
                    {{ category.points_category.name }}
                  </p>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="p-4">
              <vs-col v-if="cardInfo.activeRules && cardInfo.activeRules.length > 0">
                <vs-row class="mb-2">
                  <img :src="require('@/assets/images/active-rules/scale.png')" class="rulesIcon mr-2" />
                  <p class="detailLabel">Active Rules</p>
                </vs-row>
                <div class="ml-6" :key="ruleIndex" v-for="(rule, ruleIndex) in cardInfo.activeRules">
                  <p class="p-2 whiteText font-semibold" v-if="rule.rule">
                    {{ rule.rule.name }}
                  </p>
                  <div class="p-2 pt-0 whiteText" v-if="rule.rule">
                    {{ rule.rule.description }}
                  </div>
                </div>
              </vs-col>
              <vs-col v-if="cardInfo.activeRules && cardInfo.activeRules.length == 0">
                <p class="detailLabel">No Active Rules</p>
              </vs-col>
            </vs-row>
            <vs-row vs-justify="center" v-show="cardInfo">
              <vs-button class="font-semibold" @click="editCard(cardInfo)">Edit Card Details</vs-button>
            </vs-row>
          </vs-row>
        </vs-popup>
      </vs-row>
      <vs-popup class="holamundo addIssuer" title="Add Issuer" :active.sync="showAddIssuer">
        <vs-row vs-justify="space-between" class="p-5">
          <vs-col vs-lg="8" vs-sm="12" id="issuerName">
            <vs-row>
              <div class="ml-1 my-1">
                Issuer Name
                <span v-if="errors.issuerName.success" class="sterik">*</span>
                <span v-if="!errors.issuerName.success">*</span>
              </div>
            </vs-row>
            <vs-input placeholder="Issuer Name" v-model="issuer.name" :danger="errors.issuerName.success"
              :danger-text="errors.issuerName.msg" @input="handleAddIssuerInput" maxLength="30" class="w-full" @focus="showAddIssuerOptions = true" @blur="handleBlurOfIssuerInput"/>
              <ul v-if="showAddIssuerOptions && plaidInstitutionOptions.length" class="absolute z-10 bg-white border border-gray-300">
                <li
                  style="background-color: #343434;"
                  v-for="(option, index) in plaidInstitutionOptions"
                  :key="index"
                  @click="selectAddIssuerOption(option.name)"
                  class="p-2 cursor-pointer hover:bg-gray-100"
                >
                  {{ option.name }}
                </li>
              </ul>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" v-if="showAddIssuer">
            <div class="my-1 marginl-0 pl-0">Issuer Color</div>
            <div id="issrDrop" class="dropbtn marginl-0 mt-1" @click="toggleColorList = !toggleColorList"
              v-on-clickaway="closeColorList" :style="{ 'background-color': issuer.color }"></div>
            <div id="issrDrop" class="dropdown mt-1 pl-0">
              <div class="dropdown-content" v-show="toggleColorList">
                <div class="colorItemContainer" @click="issuer.color = issr.color" :key="index"
                  v-for="(issr, index) in issuersList">
                  <div class="colorIconStyle" :style="{ 'background-color': issr.color }"></div>
                  <span class="colorTextStyle">{{ issr.name }}</span>
                </div>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="space-between" class="p-5">
          <div class="ml-1 my-1">
            Linked Plaid Institution
            <p class="pt-2 greyText">{{ this.linkedPlaidInstitution ? this.issuer.name : 'N/A' }}</p>
          </div>
        </vs-row>
        <vs-row class="">
          <vs-row>
            <vs-col vs-lg="3" vs-sm="3" class="pl-2">
              <div class="my-1 ml-0 pl-0 pl-4">Bonus Time (Days)</div>
              <vs-input-number v-model="issuer.bonus_time" class="inline-flex m-6" min="0" />
            </vs-col>
            <vs-col vs-lg="3" vs-sm="3">
              <div class="my-1 ml-0 pl-4">Grace Time (Days)</div>
              <vs-input-number v-model="issuer.grace_time" class="inline-flex m-6" min="0" />
            </vs-col>
          </vs-row>
          <vs-row>
            <h3 class="p-5 pb-2">Active Rules</h3>
          </vs-row>
          <vs-row>
            <p class="p-5">Do you want to add active rules for this Issuer?</p>
          </vs-row>
          <vs-row v-if="errors.rules.success">
            <p class="p-5 py-3 dangerColor">{{ errors.rules.msg }}</p>
          </vs-row>
          <vs-row>
            <vs-radio v-model="issuer.activeRulesCheck" vs-name="rule" vs-value="Yes" class="m-5"
              @change="updateRule('Yes')">Yes</vs-radio>
            <vs-radio v-model="issuer.activeRulesCheck" vs-name="rule" vs-value="No" class="m-5"
              @change="updateRule('No')">No</vs-radio>
          </vs-row>
          <vs-row :key="index" v-for="(rule, index) in issuer.activeRules" :style="{
            display: issuer.activeRulesCheck == 'No' ? 'none' : 'block',
          }">
            <vs-col vs-lg="6" vs-sm="12" class="ruleOptionContainer px-3 pl-5" vs-justify="flex-start"
              style="width: 100px; overflow: hidden">
              <div class="my-2">Active Rule {{ index + 1 }}</div>
              <div id="issrList">
                <select v-model="issuer.activeRules[index].rule" class="w-full posSelect p-3">
                  <option v-for="option in modifiedList" v-bind:value="option._id" :key="option._id">
                    {{ option.rule }}
                  </option>
                </select>
              </div>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="6">
              <div class="my-2 ml-5">Effective Dates</div>
              <Datepicker v-model="issuer.activeRules[index].effectiveDate" wrapper-class="p-5 mt-0 pt-0"
                calendar-class="posCalendar" placeholder="MM/DD/YYYY" format="MM/dd/yyyy" />
            </vs-col>
            <vs-col vs-lg="3" vs-sm="6" v-if="issuer.activeRules.length > 1">
              <div class="
                  flex flex-wrap-reverse
                  items-center
                  ml-6
                  cursor
                  mt-5
                  pl-6
                  pt-6
                " @click="issuer.activeRules.splice(index, 1)">
                <MinusSquareIcon color="white" />
                <div class="addCardFont font-semibold ml-3 cursor">Remove</div>
              </div>
            </vs-col>
          </vs-row>
          <div :style="{
            display: issuer.activeRulesCheck == 'No' ? 'none' : 'block',
          }">
            <div class="flex flex-wrap-reverse items-center ml-4 cursor" @click="addNewRule">
              <PlusSquareIcon color="white" />
              <h5 class="ml-2 mt-1 cursor">Add Rule</h5>
            </div>
          </div>
          <vs-row vs-justify="flex-end">
            <vs-button class="mr-5 mb-3 issuerBtn" @click="handleAddNewIssuer">Add</vs-button>
          </vs-row>
        </vs-row>
      </vs-popup>
      <vs-popup class="holamundo" title="Result" :active.sync="addIssuerStatus">
        <h5>Issuer Added Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundo" title="Active Rules" :active.sync="issuerRulesStatus">
        <vs-row class="p-5">
          <vs-col>
            <vs-row class="p-5 pl-2 borderB">
              <div class="issuerCircle mb-1" :style="{ 'background-color': issuerDetailsforRules.color }"></div>
              <div class="mb-4 ml-4 font-semibold">
                {{ issuerDetailsforRules.name }}
              </div>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="p-5">
          <vs-row v-if="
            issuerDetailsforRules.activeRules &&
            issuerDetailsforRules.activeRules.length > 0
          ">
            <vs-row class="mb-2">
              <img :src="require('@/assets/images/active-rules/scale.png')" class="rulesIcon mr-2" />
              <p>Active Rules</p>
            </vs-row>
            <div class="ml-6 rulesContainer">
              <div class="my-2 mb-3 ml-1 whiteText" :key="index"
                v-for="(rule, index) in issuerDetailsforRules.activeRules">
                <div class="font-semibold">{{ rule.name }}</div>
                <div>{{ rule.description }}</div>
              </div>
            </div>
          </vs-row>
        </vs-row>
        <vs-row v-if="
          issuerDetailsforRules.activeRules &&
          issuerDetailsforRules.activeRules.length == 0
        ">
          <p class="ml-6 mb-3">No Active Rules</p>
        </vs-row>
      </vs-popup>

      <vs-popup class="holamundo addIssuer" title="Edit Issuer" :active.sync="showEditIssuer">
        <vs-row vs-justify="space-between" class="p-5">
          <vs-col vs-lg="8" vs-sm="12" id="issuerName">
            <vs-row>
              <div class="ml-1 my-1">
                Issuer Name
                <span v-if="errors.issuerName.success" class="sterik">*</span>
                <span v-if="!errors.issuerName.success" else>*</span>
              </div>
            </vs-row>
            <vs-input placeholder="Issuer Name" v-model="editIssuerInfo.name" :danger="errors.issuerName.success"
              :danger-text="errors.issuerName.msg" @input="validateIssuerName($event)" maxLength="30" class="w-full"
              @keydown="$event.keyCode === 69 ? $event.preventDefault() : false" />
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" v-if="showEditIssuer">
            <div class="my-1 marginl-0 pl-0">Issuer Color</div>
            <div id="issrDrop" class="dropbtn marginl-0 mt-1" @click="toggleColorListEdit = !toggleColorListEdit"
              v-on-clickaway="closeColorList" :style="{ 'background-color': editIssuerInfoColor }"></div>
            <div id="issrDrop" class="dropdown mt-1 pl-0">
              <div class="dropdown-content" v-show="toggleColorListEdit">
                <div class="colorItemContainer" @click="editIssuerInfoColor = issr.color" :key="index"
                  v-for="(issr, index) in issuersList">
                  <div class="colorIconStyle" :style="{ 'background-color': issr.color }"></div>
                  <span class="colorTextStyle">{{ issr.name }}</span>
                </div>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="">
          <vs-row>
            <vs-col vs-lg="3" vs-sm="3" class="pl-2">
              <div class="my-1 ml-0 pl-4">Bonus Time (Days)</div>
              <vs-input-number v-model="editIssuerInfo.bonus_time" class="inline-flex m-6" min="0" />
            </vs-col>
            <vs-col vs-lg="3" vs-sm="3">
              <div class="my-1 ml-0 pl-4">Grace Time (Days)</div>
              <vs-input-number v-model="editIssuerInfo.grace_time" class="inline-flex m-6" min="0" />
            </vs-col>
          </vs-row>
          <vs-row class="p-5">
            <vs-col vs-lg="6" vs-sm="12">
              <div class="my-1">Link with Plaid institution</div>
              <div class="my-1" :style="{ fontSize: '12px', color: 'gray' }">This will enable Plaid account linking in
                app</div>
              <v-select :options="plaidInstitutionOptions" v-model="selectedPlaidInstitutionOption" label="name"
                placeholder="Select an option" @search="onSearch" />
            </vs-col>
          </vs-row>
          <vs-row>
            <h3 class="p-5 pb-2">Active Rules</h3>
          </vs-row>
          <vs-row>
            <p class="p-5">Do you want to add active rules for this Issuer?</p>
            <!-- <p class="p-5" v-if="modifiedList && modifiedList.length == 0">No active rules available for this Issuer</p> -->
          </vs-row>
          <vs-row>
            <vs-row v-if="errors.rules.success">
              <p class="p-5 py-3 dangerColor">{{ errors.rules.msg }}</p>
            </vs-row>
            <vs-row>
              <vs-radio v-model="editIssuerInfo.active_rules_check" vs-name="updateRule" vs-value="Yes" class="m-5"
                @change="updateRuleForEdit('Yes')">Yes</vs-radio>
              <vs-radio v-model="editIssuerInfo.active_rules_check" vs-name="updateRule" vs-value="No" class="m-5"
                @change="updateRuleForEdit('No')">No</vs-radio>
            </vs-row>
            <vs-row :key="index" v-for="(rule, index) in editIssuerInfo.activeRules" v-bind:class="{
              hidder: editIssuerInfo.active_rules_check == 'No',
            }">
              <vs-col vs-lg="6" vs-sm="12" class="ruleOptionContainer px-3 pl-4" vs-justify="flex-start">
                <div class="my-2 ml-1">Active Rule {{ index + 1 }}</div>
                <select v-model="editIssuerInfo.activeRules[index]._id" class="w-full posSelect p-3">
                  <option v-for="option in modifiedList" v-bind:value="option._id" :key="option._id">
                    {{ option.rule }}
                  </option>
                </select>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="6">
                <div class="my-2 ml-5">Effective Dates</div>
                <Datepicker v-model="editIssuerInfo.activeRules[index].effectiveDate" wrapper-class="p-5 mt-0 pt-0"
                  calendar-class="posCalendar" placeholder="MM/DD/YYYY" format="MM/dd/yyyy" />
              </vs-col>
              <vs-col vs-lg="3" vs-sm="6" v-if="editIssuerInfo.activeRules.length > 1">
                <div class="
                    flex flex-wrap-reverse
                    items-center
                    ml-6
                    cursor
                    mt-5
                    pl-6
                    pt-6
                  " @click="editIssuerInfo.activeRules.splice(index, 1)">
                  <MinusSquareIcon color="white" />
                  <div class="addCardFont font-semibold ml-3 cursor">
                    Remove
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <vs-row :class="{ hidder: editIssuerInfo.active_rules_check == 'No' }">
              <div class="flex flex-wrap-reverse items-center ml-5 cursor" @click="addNewRuleForEdit">
                <PlusSquareIcon color="white" />
                <h5 class="ml-2 mt-1 cursor">Add Rule</h5>
              </div>
            </vs-row>
          </vs-row>
          <vs-row vs-justify="flex-end">
            <vs-button class="mr-5 mb-3 issuerBtn" @click="handleUpdateIssuer">Update</vs-button>
          </vs-row>
        </vs-row>
      </vs-popup>
      <vs-popup class="holamundo confirmPlaidModal" title="Continue without linking plaid institution" :active.sync="showConfirmPlaidLinkModal">
        <vs-row>
            <p class="p-5">Are you sure you want to continue without linking plaid institution?</p>
          </vs-row>
        <vs-row vs-justify="flex-end">
          <vs-button class="mr-5 mb-3 issuerBtn" type="border" @click="handleClosePlaidLinkModal">No</vs-button>
            <vs-button class="mr-5 mb-3 issuerBtn" @click="continueWithoutLinking">Continue without linking</vs-button>
          </vs-row>
      </vs-popup>
      <vs-popup class="holamundo confirmPlaidModal" title="Plaid Institution and Issuer names do not match" :active.sync="showConfirmPlaidNameMatchModal">
        <vs-row>
            <p class="p-5">Plaid Institution and Issuer names do not match. Are you sure you want to continue with different issuer names?</p>
          </vs-row>
        <vs-row vs-justify="flex-end">
            <vs-button class="mr-5 mb-3 issuerBtn" type="border" @click="continueWithoutLinking">Continue</vs-button>
            <vs-button class="mr-5 mb-3 issuerBtn" @click="replaceIssuerName">Replace Issuer Name</vs-button>
          </vs-row>
      </vs-popup>
      <vs-popup class="holamundo" title="Edit Issuer" :active.sync="editIssuerStatus">
        <h5>Issuer Updated Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="cardAddStatus">
        <h5>Card Added Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="cardEditStatus">
        <h5>Card Edited Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="cardApproveStatus">
        <h5>Card Approved Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundov" title="Status" :active.sync="showDeleteStatus.status">
        <h5>{{ showDeleteStatus.msg }}</h5>
      </vs-popup>
      <vs-popup class="holamundov" title="Status" :active.sync="showExistingUsersStatus.status">
        <h5>{{ showExistingUsersStatus.msg }}</h5>
        <!-- <h6 class="my-3">Users are:</h6> -->
        <div class="mt-2" style="max-height: 300px" v-if="existingUsers.length > 0">
          <div v-for="(data, index) in existingUsers" :key="index" class="my-1">
            {{
            data.user
            ? index +
            1 +
            " - " +
            data.user.firstname +
            " " +
            data.user.lastname
            : ""
            }}
          </div>
        </div>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="confirmIssuerDelete">
        <h5>Are you sure that you want to delete?</h5>
        <vs-row vs-justify="flex-end">
          <vs-button @click="deleteIssuer" class="mr-4">Yes</vs-button>
          <vs-button @click="confirmIssuerDelete = false">No</vs-button>
        </vs-row>
      </vs-popup>
    </vs-row>
  </div>
</template>

<script>
import {
  PlusSquareIcon,
  UploadCloudIcon,
  EyeIcon,
  MinusSquareIcon,
} from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import Datepicker from "vuejs-datepicker";
import vueMultiSelect from "vue-multi-select";
import EventBus from "@/event-bus.js";
import {
  validateIssuerName,
  onSubmitIssuer,
  validateRuleEffectiveDate,
  validateAlphaNumeric,
  validateRules,
} from "@/views/admin/validation";
import VueLoadImage from "vue-load-image";
import vSelect from 'vue-select';


import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  mixins: [clickaway],
  components: {
    PlusSquareIcon,
    UploadCloudIcon,
    MinusSquareIcon,
    Datepicker,
    vueMultiSelect,
    VueLoadImage,
    'v-select': vSelect
  },
  data() {
    return {
      existingUsers: [],
      confirmDelete: false,
      confirmIssuerDelete: false,
      deleteIssuerId: "",

      options: [
        "Select option",
        "options",
        "selected",
        "mulitple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],

      actionBtnClr: "#1D2024",
      showAddIssuer: false,
      showEditIssuer: false,

      primaryColor: "#4B4BF9",
      newRuleCheck: "Yes",
      showDetails: false,
      toggleColorList: false,
      toggleColorListEdit: false,

      toggleRulesList: false,

      bgc: {
        backgroundColor: "#4B4BF9",
      },
      cardsList: [],
      cardInfo: "",

      selected: [],
      itemsPerPage: 4,

      issuer: {
        name: "",
        color: "#4B4BF9",
        photo: "",
        activeRules: [],
        activeRulesCheck: "No",
        bonus_time: 25,
        grace_time: 0,
      },

      ruleItem: [{ text: "Rule Name & Description", value: "rule" }],
      rulesList: [],

      addIssuerStatus: false,
      issuersList: [],

      issuerRulesStatus: false,
      issuerDetailsforRules: "",

      editIssuerStatus: false,
      editIssuerInfo: {
        activeRulesCheck: "No",
        bonus_time: 25,
        grace_time: 0,
      },
      editIssuerInfoColor: "#fafafa",

      showDeleteStatus: {
        msg: "",
        status: false,
      },
      showExistingUsersStatus: {
        msg: "",
        status: false,
      },

      cardAddStatus: false,
      cardEditStatus: false,
      cardApproveStatus: false,
      showNoData: false,
      errors: {
        issuerName: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
      },
      validateIssuerName,
      onSubmitIssuer,
      validateRuleEffectiveDate,
      validateAlphaNumeric,
      validateRules,

      modifiedList: [],
      genericErrorMessage,
      toast,
      search: "",

      plaidInstitutionOptions: [],
      selectedPlaidInstitutionOption: null,
      searchQuery: '',
      totalIssuers: 0,
      totalIssuersLinkedWithPlaid: 0,

      linkedPlaidInstitution: false,
      showAddIssuerOptions: false,

      showConfirmPlaidLinkModal: false,
      showConfirmPlaidNameMatchModal: false,

    };
  },
  mounted() {
    this.fetchPlaidInstitutionOptions();
  },
  watch: {
    searchQuery(newQuery) {
      clearTimeout(this.timeoutSeconds);
      clearTimeout(this.timer);
      const fetchPlaidInstitutionOptions = this.fetchPlaidInstitutionOptions;
      this.timer = setTimeout(() => {
        fetchPlaidInstitutionOptions(newQuery);
      },500)
    },
  },
  methods: {
    handleBlurOfIssuerInput() {
      // Delay hiding the dropdown to allow the click event on options to register
      setTimeout(() => {
        this.showAddIssuerOptions = false;
      }, 100);
    },
    async ViewCards(inp) {
      await this.$router.push({
        name: "view-cards-v2",
        params: {
          search: inp,
        },
      });
    },
    onSearch(query) {
      this.searchQuery = query;
    },
    async selectAddIssuerOption(value) {
      this.issuer.name = value
      this.showAddIssuerOptions = false;
      this.linkedPlaidInstitution = true
    },
    async handleAddIssuerInput() {
      this.linkedPlaidInstitution = false;
      if (this.issuer.name.trim().length > 0) {
        this.showAddIssuerOptions = true;
      clearTimeout(this.timeoutSeconds);
      clearTimeout(this.timer);
      const fetchOptions = this.fetchPlaidInstitutionOptions;
      const issuerName = this.issuer.name
      this.timer = setTimeout(() => {
          fetchOptions(issuerName);
        },500)
      } else {
        this.showAddIssuerOptions = false;
      }
    },
    async fetchPlaidInstitutionOptions(query) {
      try {
        const endpoint = `${this.$ApiKeys.BASE_URL}${this.$EndPoints.SearchPlaidInstitutions}?keyword=${query}`
        const response = await this.$axios.get(endpoint)
        const institutions = response.data.data ? response.data.data.institutions.map(item => ({ institution_id: item.institution_id, name: item.name })) || [] : []
        this.plaidInstitutionOptions = institutions;
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    },
    deleteIssr(id) {
      this.deleteIssuerId = id;
      this.confirmIssuerDelete = true;
    },
    calculateRulesWidth() {
      this.modifiedList = this.rulesList;
      // this.modifiedList = [];
      // let maxLength = 80;
      // for(var i = 0; i < this.rulesList.length ; i++){
      //     this.modifiedList[i] = {
      //             rule: '',
      //             _id: ''
      //         }
      //     if(this.rulesList[i].rule.length > maxLength){
      //         this.modifiedList[i] = {
      //             rule: this.rulesList[i].rule.substr(0, maxLength) + '...',
      //             _id: this.rulesList[i]._id
      //         }
      //     }
      //     else {
      //          this.modifiedList[i] = {
      //             rule: this.rulesList[i].rule,
      //             _id: this.rulesList[i]._id
      //         }
      //     }
      // }
    },
    async editIssuer(data) {
      data.issuer_detail[0].active_rules_check =
        data.issuer_detail[0].activeRulesCount > 0 ? "Yes" : "No";
      this.editIssuerInfo = data.issuer_detail[0];
      this.editIssuerInfo.activeRules = data.rulesDetails;
      this.editIssuerInfo.bonus_time = data.issuer_detail[0].bonus_time
        ? data.issuer_detail[0].bonus_time
        : 25;
      this.editIssuerInfo.grace_time = data.issuer_detail[0].grace_time
        ? data.issuer_detail[0].grace_time
        : 0;

      this.selectedPlaidInstitutionOption = {
        institution_id: data.issuer_detail[0].plaidInstitutionId,
        name: data.issuer_detail[0].plaidInstitutionName
      }
      // this.editIssuerInfo.activeRules = await this.editIssuerInfo.activeRules.filter(function(value, index){
      //     value.effectiveDate = value.effectiveDate ? value.effectiveDate : new Date();
      //     value.rule = value.rule._id;
      //     return value.rule ? value : null;
      // });
      this.editIssuerInfoColor = data.issuer_detail[0].color;
      this.showEditIssuer = true;
      (this.errors = {
        issuerName: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
      }),
        this.getIssuers();
      this.getRules();
      // this.getRules(this.editIssuerInfo._id);
    },
    setIssuerRuleStatus(data) {
      this.issuerRulesStatus = true;
      this.issuerDetailsforRules = {
        name: data._id[0],
        color: data.issuer_detail[0].color,
        activeRules: data.rulesDetails,
      };
    },
    async editCard(cardInfo) {
      if (cardInfo) {
        await this.closeDetails();
        await this.$router.push({
          name: "edit-card",
          params: {
            card: cardInfo,
            up: this.cardInfo.upgrade_card,
            down: this.cardInfo.downgrade_card,
            pro: this.cardInfo.product_change,
          },
        });
      } else {
        await this.$router.push({ path: "/view-cards/add-card" });
      }
    },
    closeDetails() {
      this.showDetails = false;
    },
    addNewRule() {
      this.issuer.activeRules.push({ rule: "", effectiveDate: "" });
    },
    addNewRuleForEdit() {
      this.editIssuerInfo.activeRules.push({ rule: "", effectiveDate: "" });
    },
    showFilePath() {
      this.issuer.photo = this.$refs.uploadAddIssuer.files[0];
    },
    selectedColor(color) {
      this.bgc.backgroundColor = color;
      this.toggleColorList = false;
      this.issuer.color = color;
    },
    closeColorList() {
      this.toggleColorList = false;
      this.toggleColorListEdit = false;
    },
    closeRulesList() {
      this.toggleRulesList = false;
    },
    updateRule(rule) {
      this.issuer.activeRulesCheck = rule;
    },
    updateRuleForEdit(rule) {
      // this.editIssuerInfo.active_rules_check = rule;
      this.$set(
        this.editIssuerInfo,
        this.editIssuerInfo.active_rules_check,
        rule
      );
    },
    addNewData() {
      (this.issuer = {
        name: "",
        color: "#6B292B",
        photo: "",
        activeRules: [],
        activeRulesCheck: "No",
        bonus_time: 25,
        grace_time: 0,
      }),
        (this.showAddIssuer = true);
      (this.errors = {
        issuerName: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
      }),
        (this.toggleColorList = false);
      this.getIssuers();
      this.getRules();
    },
    viewDetails(rowId) {
      this.getCardInfo(rowId);
    },
    async updateIssuer(rules) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });

      return new Promise((resolve, reject) => {

        const body = {
          name: this.editIssuerInfo.name,
          color: this.editIssuerInfoColor,
          activeRules:
            this.editIssuerInfo.active_rules_check == "Yes"
              ? rules
              : [],
          activeRulesCheck:
            this.editIssuerInfo.active_rules_check == "Yes"
              ? true
              : false,
          bonusTime: this.editIssuerInfo.bonus_time,
          graceTime: this.editIssuerInfo.grace_time,
          plaidInstitutionId: this.selectedPlaidInstitutionOption ? this.selectedPlaidInstitutionOption.institution_id : undefined,
          plaidInstitutionName: this.selectedPlaidInstitutionOption ? this.selectedPlaidInstitutionOption.name : undefined,
        }

        this.$axios
          .patch(
            this.$ApiKeys.BASE_URL + this.$EndPoints.EditIssuer +
            "/" + this.editIssuerInfo._id,
            body
          )
          .then(async (res) => {
            const errors = res.data.response && res.data.response.errors && res.data.response.errors[0] && res.data.response.errors[0].response ? res.data.response.errors[0].response : null;
            this.$vs.loading.close();
            if (res.data.success == true) {

              // Updating current issuer state
              const index = this.issuersList.findIndex(item => item._id == this.editIssuerInfo._id)
              if (index >= 0) {
                this.issuersList[index].plaidInstitutionId = body.plaidInstitutionId
                this.issuersList[index].plaidInstitutionName = body.plaidInstitutionName
              }

              (this.editIssuerInfo = {
                _id: "",
                name: "",
                activeRules: [],
                activeRulesCheck: "Yes",
              }),
                (this.editIssuerInfoColor = "#fafafa"),
                this.getAllIssuers();
              this.editIssuerStatus = true;
              this.showEditIssuer = false;
            } else if (
              errors &&
              typeof errors === 'object' &&
              errors.errors &&
              Object.keys(errors.errors)[0]) {
              if (errors.errors[0].duplicateRules) {
                this.errors.rules = {
                  msg: errors.errors[0][Object.keys(errors.errors[0])[0]],
                  success: true
                }
              } else if (errors.errors[0].duplicateIssuer) {
                this.errors.issuerName = {
                  msg: errors.errors[0][Object.keys(errors.errors[0])[0]],
                  success: true
                }
              } else {
                this.toast(errors.errors[0][Object.keys(errors.errors[0])[0]])
              }
            }
            else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            this.$vs.loading.close();
            // console.log("Error in updateIssuer: ",e.response);
          });
      });
    },
    async validateUpdateIssuer(){
      if (this.onSubmitIssuer("update")) {
        let rules = [];
        await this.editIssuerInfo.activeRules.forEach(function (value, index) {
          if (value._id) {
            rules.push({
              rule: value._id,
              effectiveDate: value.effectiveDate
                ? value.effectiveDate
                : new Date(),
            });
          }
        });
        this.validateRules(
          rules.length,
          this.editIssuerInfo.active_rules_check
        );
        if (!this.errors.rules.success) {
          return rules;
        }
      }
      return false
    },
    async handleUpdateIssuer() {
      const rules = await this.validateUpdateIssuer();
      if (rules) {
        if(!this.selectedPlaidInstitutionOption || !this.selectedPlaidInstitutionOption.name){
          this.showConfirmPlaidLinkModal = true;
        }else if (this.selectedPlaidInstitutionOption && this.selectedPlaidInstitutionOption.name !== this.editIssuerInfo.name){
          this.showConfirmPlaidNameMatchModal = true
        }
        else {
          this.updateIssuer(rules);
          this.showConfirmPlaidLinkModal = false
          this.showConfirmPlaidNameMatchModal = false
        }
      }
    },
    replaceIssuerName(){
      if(this.selectedPlaidInstitutionOption && this.selectedPlaidInstitutionOption.name){
        this.editIssuerInfo.name = this.selectedPlaidInstitutionOption.name
      }
      this.showConfirmPlaidNameMatchModal = false
    },
    handleClosePlaidLinkModal(){
      this.showConfirmPlaidLinkModal = false
    },
    async continueWithoutLinking() {
      this.showConfirmPlaidLinkModal = false;
      this.showConfirmPlaidNameMatchModal = false;

      const rules = await this.validateUpdateIssuer()

      if (this.showEditIssuer && rules) {
        this.updateIssuer(rules);
      }
      if (this.showAddIssuer && rules) {
        this.addNewIssuer(rules);
      }

    },
    async validateAddNewIssuer(){
      if (this.onSubmitIssuer("add")) {
        this.issuer.activeRules = await this.issuer.activeRules.filter(
          function (value, index) {
            value.effectiveDate = value.effectiveDate
              ? value.effectiveDate
              : new Date();
            return value.rule ? value : null;
          }
        );

        this.validateRules(
          this.issuer.activeRules.length,
          this.issuer.activeRulesCheck
        );
        if (!this.errors.rules.success) {
          return true
        }
      }
      return false
    },
    async handleAddNewIssuer(){
      if(this.validateAddNewIssuer){
        if(this.linkedPlaidInstitution){
          this.addNewIssuer();
        }else{
          this.showConfirmPlaidLinkModal = true;
        }
      }
    },
    async addNewIssuer() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$ApiKeys.BASE_URL + this.$EndPoints.AddIssuer,
            {
              name: this.issuer.name,
              color: this.issuer.color,
              activeRules:
                this.issuer.activeRulesCheck == "Yes"
                  ? this.issuer.activeRules
                  : [],
              activeRulesCheck:
                this.issuer.activeRulesCheck == "Yes" ? true : false,
              bonusTime: this.issuer.bonus_time,
              graceTime: this.issuer.grace_time,
            }
          )
          .then(async (res) => {
            const errors = res.data.response && res.data.response.errors && res.data.response.errors[0] && res.data.response.errors[0].response ? res.data.response.errors[0].response : null;
            this.$vs.loading.close();
            if (res.data.success == true) {
              this.addIssuerStatus = true;
              this.showAddIssuer = false;
              this.linkedPlaidInstitution = false;
              this.getAllIssuers();
              this.issuer = {
                name: "",
                color: "#4B4BF9",
                photo: "",
                activeRules: [],
                activeRulesCheck: "Yes",
              };
            } else if (
              errors &&
              typeof errors === 'object' &&
              errors.errors.length &&
              Object.keys(errors.errors[0])[0] &&
              typeof Object.keys(errors.errors[0])[0] === 'string'
            ) {
              if (errors.errors[0].duplicateRules) {
                this.errors.rules = {
                  msg: errors.errors[0][Object.keys(errors.errors[0])[0]],
                  success: true
                }
              } else if (errors.errors[0].duplicateIssuer) {
                this.errors.issuerName = {
                  msg: errors.errors[0][Object.keys(errors.errors[0])[0]],
                  success: true
                }
              } else {
                this.toast(errors.errors[0][Object.keys(errors.errors[0])[0]])
              }
            }
            else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getAllIssuers() {
      clearTimeout(this.timeoutSeconds);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.Issuers, {
              params: {
                page: 1,
                keyword: this.search,
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              this.showNoData = true;
              if (res.data.success) {
                if (this.$route.params.add) {
                  this.cardAddStatus = this.$route.params.add;
                  this.$route.params.add = false;
                } else if (this.$route.params.edit) {
                  this.cardEditStatus = this.$route.params.edit;
                  this.$route.params.edit = false;
                } else if (this.$route.params.approve) {
                  this.cardApproveStatus = this.$route.params.approve;
                  this.$route.params.approve = false;
                  this.$root.$emit("updateApprovals", {});
                }
                resolve((this.cardsList = res.data.data));
                for (var i = 0; i < res.data.data.length; i++) {
                  this.selected[i] = [];
                }

                this.totalIssuers = res.data.data.length || 0
                this.totalIssuersLinkedWithPlaid = res.data.data.reduce((prev, curr) => {
                  if (curr.isLinkedWithPlaid) return prev + 1
                  return prev
                }, 0)
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (this.$route.params.add) {
                this.cardAddStatus = this.$route.params.add;
                this.$route.params.add = false;
              } else if (this.$route.params.edit) {
                this.cardEditStatus = this.$route.params.edit;
                this.$route.params.edit = false;
              } else if (this.$route.params.approve) {
                this.cardApproveStatus = this.$route.params.approve;
                this.$route.params.approve = false;
                this.$root.$emit("updateApprovals", {});
              }
              // console.log("Error in getAllIssuers: ",e);
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              this.$vs.loading.close();
            });
        });
      }, 500);
    },
    getCardInfo(id) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .post(this.$ApiKeys.BASE_URL + this.$EndPoints.CardInfo, {
            cardId: id,
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.showDetails = true;
              resolve((this.cardInfo = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            // console.log('Error in getCardInfo: ',e);
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getIssuers() {
      return new Promise(async (resolve, reject) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors, {
            params: {
              color: true,
            }
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.issuersList = res.data.data.issuers));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getRules(id) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise(async (resolve, reject) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.Rules, {
            params: {
              issuerId: id ? id : "",
            }
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              resolve((this.rulesList = res.data.data));
              await this.calculateRulesWidth();
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    deleteIssuer() {
      this.confirmIssuerDelete = false;
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise(async (resolve, reject) => {
        await this.$axios
          .delete(
            this.$ApiKeys.BASE_URL + this.$EndPoints.DeleteIssuer +
            "/" + this.deleteIssuerId
          )
          .then(async (res) => {
            const errMsg = res.data.response && res.data.response.errors && res.data.response.errors.length > 0 ? res.data.response.errors[0] : res.data.response && res.data.response.message ? res.data.response.message : null;
            this.$vs.loading.close();
            if (res.data.success) {
              if (res.data.message) {
                this.showDeleteStatus = {
                  msg: res.data.message,
                  status: true,
                };
              } else {
                this.showDeleteStatus = {
                  msg: "",
                  status: false,
                };
              }
              resolve();
              this.getAllIssuers();
            } else if (errMsg) {
              this.showDeleteStatus = {
                msg: errMsg,
                status: true,
              };
            }
            else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            this.showExistingUsersStatus = {
              msg: 'Cannot delete as some cards of this issuer are owned by users',
              status: true,
            };
            if (e.response.data.error && e.response.data.error.cards) {
              this.showExistingUsersStatus = {
                msg: e.response.data.error.cards,
                status: true,
              };
              this.existingUsers = e.response.data.data;
            } else {
              this.showExistingUsersStatus = {
                msg: "",
                status: false,
              };
              this.existingUsers = [];
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
            }
          });
      });
    },
  },
  created() {
    EventBus.$emit("resetToggleGroup", true);
    this.getAllIssuers();
  },
};
</script>

<style>
@import "./style.css";
</style>

